
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft1 as ObiWindShaft1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-1.js';
 
 
 

 
 export const ObiWindShaft1 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-1',
   elementClass: ObiWindShaft1Element,
   events: {
     
   }
  });
 
 